const formatAddress = (address) =>
	`${address.address1} ${address.address2 ?? ""}, ${address.zip} ${address.city}, ${address.countryCode ?? ""}`;

export default formatAddress;